import React from 'react';
import './PrepwiseLogo.css';

interface PrepwiseLogoProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

const PrepwiseLogo: React.FC<PrepwiseLogoProps> = ({ size = 'medium', className = '' }) => {
  return (
    <div className={`prepwise-logo prepwise-logo-${size} ${className}`}>
      <div className="logo-square">
        <span className="logo-letter">P</span>
      </div>
    </div>
  );
};

export default PrepwiseLogo;

